/** Symmetric padding helpers + named presets for the recurring `{ paddingLeft, paddingRight, paddingTop?, paddingBottom? }` shape.
 * `buildSymmetricPadding(4, 2)` adds the top/bottom pair. Presets: `PAGE_GUTTER_LG` (L4/R4), `PAGE_GUTTER_XL` (L6/R6),
 * `BUTTON_PILL_PADDING` (L4/R4/T2/B2). Values compute from the const spacing scale, which is why this lives outside the const leaf. */

import { spacingScale as spacing } from '@federa/const/design-token-scales';

type SpacingKey = keyof typeof spacing;

/** Build a symmetric padding object; when `y` is provided it includes `paddingTop` + `paddingBottom`, otherwise only horizontal padding. */
export function buildSymmetricPadding(x: SpacingKey): {
	paddingLeft: string;
	paddingRight: string;
};
export function buildSymmetricPadding(
	x: SpacingKey,
	y: SpacingKey,
): {
	paddingLeft: string;
	paddingRight: string;
	paddingTop: string;
	paddingBottom: string;
};
export function buildSymmetricPadding(
	x: SpacingKey,
	y?: SpacingKey,
): {
	paddingLeft: string;
	paddingRight: string;
	paddingTop?: string;
	paddingBottom?: string;
} {
	if (y === undefined) {
		return {
			paddingLeft: spacing[x],
			paddingRight: spacing[x],
		};
	}
	return {
		paddingLeft: spacing[x],
		paddingRight: spacing[x],
		paddingTop: spacing[y],
		paddingBottom: spacing[y],
	};
}

/** Page-edge gutter, L4/R4 (most common authenticated-page horizontal padding). */
export const PAGE_GUTTER_LG = {
	paddingLeft: spacing[4],
	paddingRight: spacing[4],
} as const;

/** Page-edge gutter, L6/R6 (slightly wider; OTP, modal-section gutters). */
export const PAGE_GUTTER_XL = {
	paddingLeft: spacing[6],
	paddingRight: spacing[6],
} as const;

export const BUTTON_PILL_PADDING = {
	paddingLeft: spacing[4],
	paddingRight: spacing[4],
	paddingTop: spacing[2],
	paddingBottom: spacing[2],
} as const;
